export default {
  apiKey: '',
}
